// extracted by mini-css-extract-plugin
export default {"container":"DropFilesHidden_container__v6lEe","container_inner":"DropFilesHidden_container_inner__YU4il"};